import React, { Component } from 'react';
import $ from 'jquery';
import Script from 'react-load-script';
import { BrowserRouter as Router, Switch, Route, Link, browserHistory } from 'react-router-dom';
import { Timeline } from 'react-twitter-widgets';
import FacebookProvider, { Page } from 'react-facebook';
import Helmet from 'react-helmet';

class SocMedia extends Component {

  componentDidMount(){

      (function(d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s); js.id = id;
            js.src = "//connect.facebook.net/en_GB/sdk.js#xfbml=1&version=v2.9";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
    
        
        }

	render() {
    return (
        <div>

        <Helmet
                title="Social Media Activities | RAT Films | Film Makers in India"
                meta={[
                  { name: 'description', content: "Connect with us on social media and know the latest updates, tweets and posts from Rat films." },
                  

                  ]}
              />
              <div id="fb-root"></div>
        <section className="page-section soc-media ">
          <div className="container ">
            <h3 className="heading main">SOCIAL MEDIA</h3>
              <div className="row">
                <div className="col-sm-6">
                  <div className="fb-frame">
                    <div className="fb-page fb_iframe_widget fb_iframe_widget_fluid" data-href="https://www.facebook.com/ratfilms" data-tabs="timeline" data-small-header="true" data-hide-cover="false" data-width="500" data-height="500" data-show-facepile="false" fb-xfbml-state="rendered" fb-iframe-plugin-query="app_id=&amp;container_width=570&amp;height=500&amp;hide_cover=false&amp;href=https%3A%2F%2Fwww.facebook.com%2Fratfilms&amp;locale=en_GB&amp;sdk=joey&amp;show_facepile=false&amp;small_header=true&amp;tabs=timeline&amp;width=500">
                      <span >
                      <iframe name="f2f74807bd4a15" width="500px" height="500px" frameborder="0" allowtransparency="true" allowfullscreen="true" scrolling="no" allow="encrypted-media" title="fb:page Facebook Social Plugin" src="https://www.facebook.com/v2.9/plugins/page.php?app_id=&amp;channel=http%3A%2F%2Fstaticxx.facebook.com%2Fconnect%2Fxd_arbiter%2Fr%2F1e2RywyANNe.js%3Fversion%3D42%23cb%3Df1d5206818413a%26domain%3Drat.ratfilms.in%26origin%3Dhttp%253A%252F%252Frat.ratfilms.in%252Ff3da3e54f9f7c34%26relation%3Dparent.parent&amp;container_width=570&amp;height=500&amp;hide_cover=false&amp;href=https%3A%2F%2Fwww.facebook.com%2Fratfilms&amp;locale=en_GB&amp;sdk=joey&amp;show_facepile=false&amp;small_header=true&amp;tabs=timeline&amp;width=500" 
                       className="">
                      </iframe>
                      </span>
                      </div>
                  </div>
                  
                </div>
                <div className="col-sm-6">
                  <div className="twt-frame">
                    <a className="twitter-timeline" href="https://twitter.com/RATFilmsIndia">Tweets by RATFilmsIndia</a> 
                    <Timeline
                      dataSource={{
                        sourceType: 'profile',
                        screenName: 'twitterdev'
                      }}
                      options={{
                        username: 'RATFilmsIndia',
                        height: '500'
                      }}
                      onLoad={() => console.log('Timeline is loaded!')}
                    /> 
                  </div>
                </div>
              </div>
          </div>
        </section>
		
        </div>

		
    );
  }
}

export default SocMedia;


// WEBPACK FOOTER //
// ./src/components/soc_media.js